module.exports = __webpack_public_path__ + "img/5.f6b6aa27.png";